import React, { useRef, useState} from 'react';
import Background from "./components/backgroundImage";
import {Images, Videos} from "./AssetReferences";
import s from "./mobileScreen_style.module.css";
import AboutPage from "./pages/about_page";
import {getRandomInt} from "./components/audioUtils";
import {useTitle} from "./hooks/UseTitle";
import {PageTitles} from "./SitePages";

export default function MobileScreen() {
    useTitle(PageTitles.Error)
   
    const [displayAbout, setDisplayAbout] = useState(false)
    
    const imgRef = useRef(null)
    const textAreaRef = useRef(null)

    // Using a different imgae due to seizure issues.    
    // const bgImageSrc = useRef(`${Images.MobilePopupBGPathStart + getRandomInt(1, 3) + Images.MobilePopupBGPathEnd}`); 
    const bgImageSrc = useRef(Images.MobilePopupBGGif);

    function setTextAreaHeightAndWidth() {
        if (!imgRef.current || !textAreaRef.current) return;

        const img = imgRef.current;
        textAreaRef.current.style.maxWidth = Math.min(window.innerWidth, img.offsetWidth - getPixelsFromVW(25)) + "px";
        textAreaRef.current.style.height = Math.min(window.innerHeight, img.offsetHeight - getPixelsFromVH(33)) + "px";
    }

    function getPixelsFromVW(vw) {
        return Math.round((vw / 100) * window.innerWidth);
    }

    function getPixelsFromVH(vh) {
        return Math.round((vh / 100) * window.innerHeight);
    }

    function handleAboutPageDisplayChange(newValue) {
        setDisplayAbout(newValue);
        setTimeout(() => setTextAreaHeightAndWidth(), 0)
    }

    return (
        <div id={"mobile screen"}
             style={{
                 width: "100%", height: "100%",
                 display: "flex", justifyContent: "center", alignContent: "center"
             }}
        >

            <Background src={bgImageSrc.current}/>
            
            {/* // Below: setting image size dynamically */}
            {/*<img*/}
            {/*    alt={"glitchy background"}*/}
            {/*    src={bgImageSrc.current}*/}
            {/*    ref={imgRef}*/}
            {/*    style={{*/}
            {/*        position: "fixed",*/}
            {/*        height: "100%",*/}
            
            {/*    }}*/}
            {/*    onLoad={setTextAreaHeightAndWidth}*/}
            {/*/>*/}

            {displayAbout
                ?
                <AboutPage display={displayAbout} id={"about page"} OnExit={() => handleAboutPageDisplayChange(false)}/>
                :
                <div ref={textAreaRef} className={s.textArea}
                     style={{display: displayAbout ? "none" : "block",}}>

                    <div>   
                        <Heading/>
                        <Content onPlantClick={() => handleAboutPageDisplayChange(true)}/>
                    </div>
                </div>
            }
        </div>
    )
}

function Heading() {
    return (
        <div id={"heading"} className={s.heading}>
            <div>Symbiosis</div>
        </div>
    )
}

function Content({onPlantClick}) {
    return (
        <div id={"content"} className={s.content}>
            <p>
                Sorry, but this site is not compatible with mobile devices or tablets. Please open on a computer
                browser to experience. To find out more about the Symbiosis installation and the Organism Collective, press the button below.
            </p>

            <OpenAboutLink onClick={onPlantClick}/>
        </div>
    )
}

function OpenAboutLink({onClick}) {
    return (
        <div className={s.aboutPlantLinkContainer}>
            <img
                className={s.aboutPlantLink}
                alt={"link to about page"}
                src={Images.AboutHover}
                onClick={onClick}
            />
        </div>
    )
}